import { apiFetchJson } from '@wundo/client/api.ts';

/** An OpenAI batch job the pipeline has in flight, or has had. */
export interface PipelineBatch {
  id: string;
  batch_id: string;
  type: string;
  status: string;
  created_at: string;
  completed_at: string | null;
}

export interface PipelineStats {
  classification: {
    total_messages: number;
    detected: number;
    needing_detection: number;
    questions: number;
    fully_classified: number;
    needing_classification: number;
    pending_in_batch: number;
  };
  session_analysis: {
    total_sessions: number;
    fully_analyzed: number;
    needing_analysis: number;
    analyzers: Record<string, number>;
  };
  reviews: {
    total: number;
    needing_review: number;
    by_severity: {
      critical: number;
      high: number;
      medium: number;
      low: number;
      ok: number;
    };
  };
  batches: PipelineBatch[];
}

export async function fetchPipelineStats(): Promise<PipelineStats> {
  return apiFetchJson<PipelineStats>('/pipeline-stats');
}
